import { render, staticRenderFns } from "./EditableCoOwnersListDialog.vue?vue&type=template&id=06aa0e60"
import script from "./EditableCoOwnersListDialog.vue?vue&type=script&lang=ts"
export * from "./EditableCoOwnersListDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports